'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('recoveryService', function($q, apiEndpointFactory) {

  var forgotAccountApi = apiEndpointFactory.new({
    endpointUrl: '/forgot-account',
    allowedMethods: ['post']
  });

  return {
    forgotAccount: function(email, dob) {
      return forgotAccountApi.post({
        'email': email,
        'dob': dob
      }).then(function(response) {
        return response;
      }, function(response) {
        return $q.reject(response);
      });
    }

  };
});
